import { DomainColors, PayoutStatus, PayoutStatuses } from "@/domain/contracts";
import moment from "moment";

export const payoutStatus = (
  status: PayoutStatus,
  date?: string,
): Record<string, { status: string; color: string }> => {
  switch (status) {
    case PayoutStatuses.paid:
      return {
        financeScreen: {
          status: "Repasse realizado",
          color: DomainColors.primary,
        },
        financeAppointmentsScreen: {
          status: `Repasse realizado em ${moment(date).format("DD/MM/YYYY")}`,
          color: DomainColors.primary,
        },
        payoutDetailScreen: {
          status: "Realizado",
          color: DomainColors.success,
        },
        appointmentDetail: {
          status: "Realizado",
          color: DomainColors.success,
        },
      };
    case PayoutStatuses.failed:
      return {
        financeScreen: {
          status: "Repasse com falha",
          color: DomainColors.danger,
        },
        financeAppointmentsScreen: {
          status: `Repasse com falha em ${moment(date).format("DD/MM/YYYY")}`,
          color: DomainColors.danger,
        },
        payoutDetailScreen: {
          status: "Falha no repasse",
          color: DomainColors.warning,
        },
        appointmentDetail: {
          status: "Falha no repasse",
          color: DomainColors.warning,
        },
      };
    case PayoutStatuses.canceled:
      return {
        financeScreen: {
          status: "Repasse cancelado",
          color: DomainColors.danger,
        },
        financeAppointmentsScreen: {
          status: `Repasse cancelado em ${moment(date).format("DD/MM/YYYY")}`,
          color: DomainColors.danger,
        },
        payoutDetailScreen: {
          status: "Cancelado",
          color: DomainColors.danger,
        },
        appointmentDetail: {
          status: "Cancelado",
          color: DomainColors.danger,
        },
      };
    case PayoutStatuses.in_transit:
      return {
        financeScreen: {
          status: "Repasse em trânsito",
          color: DomainColors.primary50,
        },
        financeAppointmentsScreen: {
          status: `Repasse em trânsito`,
          color: DomainColors.primary50,
        },
        payoutDetailScreen: {
          status: "Em trânsito",
          color: DomainColors.primary50,
        },
        appointmentDetail: {
          status: "Em trânsito",
          color: DomainColors.primary50,
        },
      };
    case PayoutStatuses.pending:
    default:
      return {
        financeScreen: {
          status: "Aguardando repasse",
          color: DomainColors.primary50,
        },
        financeAppointmentsScreen: {
          status: `Aguardando repasse`,
          color: DomainColors.primary50,
        },
        payoutDetailScreen: {
          status: "Aguardando",
          color: DomainColors.primary50,
        },
        appointmentDetail: {
          status: "Aguardando",
          color: DomainColors.primary50,
        },
      };
  }
};

export const payoutType = (type: string, reportingCategory: string): string => {
  const key = `${type}/${reportingCategory}`;
  switch (key) {
    case "adjustment/fee":
      return "Reembolso da taxa";
    case "payment/charge":
      return "Pagamento da sessão";
    case "payment_refund/refund":
      return "Reembolso da sessão";
    case "payout/payout":
      return "Montante do repasse";
    case "payout_failure/payout_reversal":
      return "Reembolso de falha no repasse";
    default:
      return type;
  }
};
